<template>
  <DBox :id="'cmp-royalty-royalty_accounts-sidewindow-b2b-access'" :addButton="false" :addLink="true"
    :addLinkLabel="`${$t('add')} ${$t('b2b_access')}`" @addClick="onAddClick">
    <NTable id="cmp-royalty-royalty_accounts-sidewindow-b2b-access" class="h1 dbox1" :config="tableConfig"
      :headers="headers" :items="list" :showNoItems="false">
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('b2b_access')">
            <span class="txtov" :title="item['user_name']">
              {{ item["user_name"] }}
            </span>
          </td>
          <td v-bind="tdcon('given_name')">
            <span class="txtov" :title="item['given_name']">
              {{ item["given_name"] }}
            </span>
          </td>
          <td v-bind="tdcon('currency_id')">

            <Dropdown2 class="dbox1" :showLabel="false" :disabled="item['disabled']" :options="languagesTV"
              :selected="languagesTV.find((b) => b.value == item.language)" :placeholder="'Select language'"
              v-on:selectedChange="(e) => onDropdownChange('language', e, item)
                " :bb="'0px'" />
          </td>
          <td v-bind="tdcon('email')">
            <span @click.stop="e => emailLink(item)">
              <img v-if="item['email'] && item['email'] !== ''" src="static/icons/email/email-grey.svg"
                class="dt-icon v5 s2" :alt="item['email']" :title="item['email']" />
            </span>
          </td>

          <td v-bind="tdcon('options')">
            <img src="static/icons/delete.svg" @click.stop="e => onExternalUserDelete(item)" class="dt-icon v5 s2"
              alt />
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import { sendMailHref } from "../../../../utility";
import { RoyaltyStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { accountsRoyaltyActions } from "../../store/accounts/actions";
import { AccountsService } from "../../services/accounts.service";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { clientName } from "../../../../services/http/http-client";

export default {
  components: {
    DBox,
    NTable
  },
  props: ["selectedAccountDetails"],
  data: function () {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      })
    };
  },
  computed: {
    list: function () {
      return this.selectedAccountDetails?.related_ext_users || [];
    },
    languagesTV: function () {
      return this.selectedAccountDetails?.languagesTV || [];
    },
    headers: function () {
      return [
        createTableHeader("b2b_access", {
          f: 0.7,
          minw: 100
        }),
        createTableHeader("given_name"),
        createTableHeader("language"),
        createTableHeader("email", { mw: 50 }),
        createTableHeader("options", { text: false, mw: 30 })
      ];
    }
  },
  methods: {
    ...mapActionObject(storeNS, accountsRoyaltyActions),

    onAddClick: function () {
      this.$emit("add_click", "add_access_form");
    },
    onExternalUserDelete: async function (item) {
      const confirmationResult = await confirmDelete(
        "B2B Access",
        item.given_name
      );
      if (confirmationResult === "OK") {
        console.log(item);
        const res = await AccountsService.deleteExternalUser(
          item.external_users_permission_id
        );

        if (res?.data?.done == 1) {
          const related_ext_users = this.selectedAccountDetails?.related_ext_users?.filter(
            b =>
              b.external_users_permission_id !==
              item.external_users_permission_id
          );

          this[ActionTypes.RoyaltyExternalUser.SET.ALL]({
            royalty_account_id: this.selectedAccountDetails?.account
              ?.royalty_account_id,
            related_ext_users: [...related_ext_users] || []
          });
        }
      }
    },
    onDropdownChange: function (name, value, item) {
      item[name] = value.value;
      this.$emit("changed", {
        name,
        value: value.value,
        kVal: item.external_user_id,
        table: "external_users",
      });

    },
    async emailLink(item) {
      const { account } = this.selectedAccountDetails
      const { external_user_id } = item
      const { invoice_project_id } = account

      let res = await AccountsService.shareInvitationEmailData(
        external_user_id, invoice_project_id
      );
      console.log('this.res', res)
      let { subject, email_body, reply_to } = res.data.share_invitation_email_data;


      sendMailHref({
        mails: [reply_to],
        body: email_body,
        subject: subject
      });
    }
  }
};
</script>

<style lang="scss">
.cmp-royalty-royalty_accounts-sidewindow-b2b-access {}
</style>
